import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuthToggleContext } from "../../components/providers/AuthProvider.jsx";
import { SlideCard, BrandButton, TextInput } from "../../components/ui/index.js";
import { Mail, MailCheck } from "lucide-react";

function ForgotPassword() {
    const { handleForgotPassword } = useAuthToggleContext();
    const [email, setEmail]   = useState('');
    const [sent, setSent]     = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await handleForgotPassword(email);
        setLoading(false);
        setSent(true);
    };

    const sentContent = (
        <div className="flex flex-col items-center gap-3 py-4">
            <MailCheck size={48} className="text-primary" />
            <h2 className="text-2xl font-extrabold dark:text-white text-gray-900 text-center">
                Email enviado
            </h2>
            <p className="text-center text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                Si <strong>{email}</strong> está registrado recibirás un enlace para restablecer tu contraseña.
                <br />Revisa también la carpeta de spam.
            </p>
            <Link to="/login">
                <BrandButton variant="outline" size="md">Volver al login</BrandButton>
            </Link>
        </div>
    );

    const formContent = (
        <>
            <div>
                <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-1">
                    Recuperar acceso
                </p>
                <h2 className="text-2xl md:text-3xl font-extrabold dark:text-white text-gray-900">
                    ¿Olvidaste tu contraseña?
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Introduce tu email y te enviaremos un enlace para crear una nueva contraseña.
                </p>
            </div>

            <form onSubmit={submit} className="flex flex-col gap-4">
                <TextInput
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                    placeholder="tu@email.com"
                    leftIcon={<Mail size={16} />}
                />

                <BrandButton
                    variant="solid"
                    size="md"
                    type="submit"
                    className="w-full justify-center"
                    disabled={loading}
                >
                    {loading ? 'Enviando…' : 'Enviar enlace'}
                </BrandButton>
            </form>

            <p className="text-center text-xs text-gray-500 dark:text-gray-400">
                <Link to="/login" className="text-brand-red hover:underline font-semibold">
                    Volver al login
                </Link>
            </p>
        </>
    );

    const content = sent ? sentContent : formContent;

    return (
        <div className="flex flex-col md:flex-row h-full w-full">
            <div className="md:hidden flex flex-col h-full w-full">
                <div className="flex-shrink-0 dark:bg-base-300/80 bg-white/85 backdrop-blur-md border-b border-white/10 dark:border-white/5 px-6 py-8 flex flex-col gap-5">
                    {content}
                </div>
                <div className="flex-1" />
            </div>
            <div className="hidden md:flex flex-1 items-center justify-end w-full h-full px-8 lg:px-12">
                <SlideCard
                    direction="right"
                    className="glassCard rounded-2xl shadow-xl w-[50%] lg:w-[40%] max-h-[88vh] overflow-y-auto p-8 flex flex-col gap-5"
                >
                    {content}
                </SlideCard>
            </div>
        </div>
    );
}

export default ForgotPassword;
